class PrivateSaleForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.formEl = this.els?.form?.element
    this.emailEl = this.els?.email?.element
    this.checkboxEl = this.els?.checkbox?.element

    this.listeners.add(this.formEl, 'submit', this.onSubmitHandler.bind(this))
    this.listeners.add(this.emailEl, 'input', this.onEmailInput.bind(this))
    this.listeners.add(
      this.checkboxEl,
      'input',
      this.onCheckboxInput.bind(this),
    )
  }

  onSubmitHandler (e) {
    e.preventDefault()

    this.checkForm()
  }

  onEmailInput () {
    this.invalidField(this.emailEl, false)
  }

  onCheckboxInput () {
    this.invalidField(this.checkboxEl, false)
  }

  checkForm () {
    this.invalidField(this.emailEl, !this.emailEl.validity.valid)
    this.invalidField(this.checkboxEl, !this.checkboxEl.checked)

    if (!this.checkboxEl.checked || !this.emailEl.validity.valid) return

    if (this.externalEls?.container?.exists) {
      this.externalEls.container.elements.forEach((el) => {
        el.setAttribute('aria-busy', 'true')
      })
    }

    this.setAttribute('aria-busy', 'true')

    this.newsletterSubscribe(this.emailEl.value)
  }

  invalidField (el, invalid) {
    el.classList.toggle('ps-Form_Input-invalid', invalid)
  }

  async newsletterSubscribe (emailAddress) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.listId,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.onSuccess()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  async onSuccess () {
    await this.setCartAttribute()

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRIVATE_SALE.ON_SUCCESS)

    if (this.externalEls?.locked?.exists) {
      this.externalEls.locked.elements.forEach((el) => {
        el.setAttribute('aria-hidden', 'true')
      })
    }

    if (this.externalEls?.unlocked?.exists) {
      this.externalEls.unlocked.elements.forEach((el) => {
        el.removeAttribute('hidden')
        el.removeAttribute('aria-hidden')
      })
    }

    if (this.externalEls?.container?.exists) {
      this.externalEls.container.elements.forEach((el) => {
        el.removeAttribute('aria-busy')
      })
    }

    this.removeAttribute('aria-busy')
  }

  async setCartAttribute () {
    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: 'true',
        },
      }),
    })
  }

  get storageName () {
    return 'bao_private_sale_unlocked'
  }

  get listId () {
    return this.dataset.listId
  }
}

if (!customElements.get('private-sale-form')) {
  customElements.define('private-sale-form', PrivateSaleForm)
}
